import { RootReducer } from '../redux/rootReducer'
import React, { useRef } from 'react'
import { useSelector } from 'react-redux'

interface Props {
  send: (message: string, payload: any) => void
}

function throttleWithFinalCall(func: (...args: any[]) => void, delay: number) {
  let lastCall = 0
  return function (...args: any[]) {
    const now = Date.now()
    if (now - lastCall >= delay) {
      lastCall = now
      func(...args)
    }
  }
}

const CursorMovementCapture = ({ send }: Props) => {
  const scale = useSelector((state: RootReducer) => state.slidesReducer.scale)
  const slideRef = useRef<HTMLDivElement | null>(null)
  const { cursorEnabled } = useSelector((state: RootReducer) => state.slidesReducer)
  const user = useSelector((state: RootReducer) => state.slidesReducer.user)
  const onMouseMove = throttleWithFinalCall((e: React.MouseEvent<HTMLDivElement>) => {
    if (slideRef.current && cursorEnabled) {
      const rect = slideRef.current.getBoundingClientRect()
      const x = (e.clientX - rect.left) / scale
      const y = (e.clientY - rect.top) / scale
      send('cursor_position', { x, y, to: user === 'tutor' ? 'student' : 'tutor' })
    }
  }, 100)

  return (
    <div
      onMouseUp={() => send('cursor_up', {})}
      onMouseDown={() => send('cursor_down', {})}
      ref={slideRef}
      onMouseMove={onMouseMove}
      style={{
        cursor: cursorEnabled ? 'crosshair' : 'default',
        pointerEvents: cursorEnabled ? 'auto' : 'none'
      }}
      className="absolute top-0 left-0 w-full h-full"></div>
  )
}

export default CursorMovementCapture
